export default __webpack_public_path__ + "static/media/banner-2.c914ca72.webp";